<mat-card-title>{{ data.Title }}</mat-card-title>

<mat-dialog-content>
  <div class="p-20">
    {{ data.Text }}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ 'popup.yes' | translate }}
  </button>
  <button mat-raised-button color="primary" mat-dialog-close>
    {{ 'popup.no' | translate }}
  </button>
</mat-dialog-actions>
